/* Copiar el código no activa el descuento. */
(() => {
  'use strict';

  if (window.KinegunCouponCopy) return;
  window.KinegunCouponCopy = true;

  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-kg-copy]');
    if (!button || button.disabled) return;

    const status = button.closest('.kg-info')
      ?.querySelector('[data-kg-copy-status]');

    button.disabled = true;

    try {
      if (!navigator.clipboard?.writeText) {
        throw new Error('Clipboard unavailable');
      }

      await navigator.clipboard.writeText(button.dataset.kgCopy);

      button.dataset.copied = 'true';
      button.setAttribute('aria-label', 'Cupón copiado');

      if (status) {
        status.textContent = 'Cupón ' + button.dataset.kgCopy + ' copiado';
        status.dataset.error = 'false';
      }

      setTimeout(() => {
        delete button.dataset.copied;

        button.setAttribute(
          'aria-label',
          'Copiar cupón ' + button.dataset.kgCopy
        );

        if (status) status.textContent = '';
      }, 2200);
    } catch (_) {
      if (status) {
        status.textContent = 'Selecciona el código para copiarlo.';
        status.dataset.error = 'true';
      }
    } finally {
      button.disabled = false;
    }
  });
})();

/*
 * Shopify aplica el descuento mediante su enlace nativo.
 * Este código conserva la selección para mostrar el aviso al llegar.
 * No calcula descuentos ni comprueba las condiciones del cupón.
 */
(() => {
  'use strict';

  if (window.KinegunCoupons) return;

  const bar = document.querySelector('[data-kg-bar]');
  if (!bar) return;

  const KEY = 'kinegun.coupon.v1';
  const TTL = 24 * 60 * 60 * 1000;
  const PENDING_KEY = 'kinegun.coupon.pending.v1';
  const PENDING_TTL = 5 * 60 * 1000;

  const get = name => bar.querySelector(`[data-kg-${name}]`);
  const space = document.querySelector('[data-kg-space]');

  const validCode = value =>
    typeof value === 'string' &&
    value.trim().length > 0 &&
    value.length <= 80 &&
    !/[\x00-\x1f\x7f,]/.test(value);

  const localPath = (value, segment) => {
    try {
      const url = new URL(value, location.origin);

      if (
        url.origin !== location.origin ||
        !url.pathname.includes(`/${segment}/`)
      ) {
        return null;
      }

      const view = segment === 'pages'
        ? url.searchParams.get('view')
        : null;

      return url.pathname + (
        view && /^[a-zA-Z0-9_-]+$/.test(view)
          ? '?view=' + encodeURIComponent(view)
          : ''
      );
    } catch (_) {
      return null;
    }
  };

  const read = key => {
    try {
      return JSON.parse(sessionStorage.getItem(key) || 'null');
    } catch (_) {
      return null;
    }
  };

  const write = (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (_) {}
  };

  const remove = key => {
    try {
      sessionStorage.removeItem(key);
    } catch (_) {}
  };

  const validSelection = (value, ttl) => Boolean(
    value &&
    validCode(value.code) &&
    localPath(value.collection, 'collections') &&
    Number.isFinite(value.at) &&
    value.at <= Date.now() &&
    Date.now() - value.at < ttl
  );

  const normalize = value => ({
    code: value.code.trim(),
    collection: localPath(value.collection, 'collections'),
    landing: localPath(value.landing, 'pages'),
    at: value.at
  });

  let selection = null;
  let dismissed = false;
  let lastPaint = '';

  const save = () => {
    if (selection) write(KEY, selection);
    else remove(KEY);
  };

  const stored = read(KEY);

  if (validSelection(stored, TTL)) {
    selection = normalize(stored);
  } else {
    remove(KEY);
  }

  const page = new URL(location.href);
  const incoming = page.searchParams.get('kg_coupon');
  const pending = read(PENDING_KEY);
  const pendingValid = validSelection(pending, PENDING_TTL);

  const arrived = pendingValid &&
    localPath(location.pathname, 'collections') ===
    localPath(pending.collection, 'collections');

  if (validCode(incoming) && localPath(location.pathname, 'collections')) {
    selection = {
      code: incoming.trim(),
      collection: location.pathname,
      landing: arrived &&
        pending.code.toUpperCase() === incoming.trim().toUpperCase()
          ? localPath(pending.landing, 'pages')
          : localPath(page.searchParams.get('kg_landing'), 'pages'),
      at: Date.now()
    };

    save();
    remove(PENDING_KEY);
  } else if (arrived) {
    selection = normalize(pending);
    selection.at = Date.now();

    save();
    remove(PENDING_KEY);
  } else if (!pendingValid) {
    remove(PENDING_KEY);
  }

  /*
   * Guardar la selección antes de seguir el enlace de Shopify.
   * El aviso se muestra al llegar a la colección correspondiente.
   */
  document.addEventListener('click', event => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest?.('a.kg-activate[href]');

    if (
      !link ||
      link.hasAttribute('download') ||
      (link.target && link.target !== '_self')
    ) {
      return;
    }

    try {
      const activation = new URL(link.href, location.origin);
      const match = activation.pathname.match(/\/discount\/([^/]+)\/?$/);

      if (activation.origin !== location.origin || !match) return;

      const code = decodeURIComponent(match[1]);
      const redirect = activation.searchParams.get('redirect');

      if (!validCode(code) || !redirect) return;

      const collection = localPath(redirect, 'collections');
      if (!collection) return;

      write(PENDING_KEY, {
        code: code.trim(),
        collection,
        landing: localPath(location.href, 'pages'),
        at: Date.now()
      });
    } catch (_) {}
  });

  if (
    page.searchParams.has('kg_coupon') ||
    page.searchParams.has('kg_landing')
  ) {
    page.searchParams.delete('kg_coupon');
    page.searchParams.delete('kg_landing');

    try {
      history.replaceState(
        history.state,
        '',
        page.pathname + page.search + page.hash
      );
    } catch (_) {}
  }

  function resize() {
    if (!space) return;

    space.hidden = bar.hidden;

    const bottom = Math.max(
      0,
      parseFloat(getComputedStyle(bar).bottom) || 0
    );

    space.style.height = bar.hidden
      ? '0px'
      : `${bar.getBoundingClientRect().height + bottom}px`;
  }

  function paint() {
    if (selection && Date.now() - selection.at >= TTL) {
      selection = null;
      save();
    }

    if (!selection || dismissed) {
      bar.hidden = true;
      resize();
      return;
    }

    const signature = [
      selection.code,
      selection.collection,
      selection.landing
    ].join('|');

    if (lastPaint !== signature) {
      get('code').textContent = selection.code;
      get('suffix').textContent = ' ya está activado';
      get('detail').textContent = '';
      get('icon').textContent = '✓';
      get('collection').href = selection.collection;
      get('change').href = selection.landing || bar.dataset.couponsUrl;

      bar.dataset.state = 'active';
      lastPaint = signature;
    }

    bar.hidden = false;
    resize();
  }

  /*
   * Limpia únicamente el aviso.
   * Invocar después de que Shopify confirme que se eliminó el descuento.
   */
  function clearNotice(code) {
    if (
      code &&
      selection &&
      String(code).trim().toUpperCase() !== selection.code.toUpperCase()
    ) {
      return;
    }

    selection = null;
    remove(KEY);

    const queued = read(PENDING_KEY);

    if (
      !code ||
      !queued ||
      String(code).trim().toUpperCase() === String(queued.code).toUpperCase()
    ) {
      remove(PENDING_KEY);
    }

    paint();
  }

  get('close').addEventListener('click', () => {
    dismissed = true;
    paint();
  });

  document.addEventListener('kinegun:coupon-cleared', event => {
    clearNotice(event.detail?.code);
  });

  window.addEventListener('pageshow', paint);
  window.addEventListener('focus', paint);

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) paint();
  });

  if ('ResizeObserver' in window) {
    new ResizeObserver(resize).observe(bar);
  }

  window.addEventListener('resize', resize);

  window.KinegunCoupons = Object.freeze({
    refresh: paint,
    clearNotice
  });

  paint();
})();